import React, { useEffect } from 'react';
import classNames from 'classnames';
import useSessionstorage from '@rooks/use-sessionstorage';
import { useHistory } from 'react-router-dom';

export const ResponseWithoutScanTemperature = (props) => {
  const history = useHistory();

  const [submitedData] = useSessionstorage('submitedData');
  const [siteOptions] = useSessionstorage('siteOptions');
  const [employeeId] = useSessionstorage('employeeId');
  const [redirectType] = useSessionstorage('redirectType');
  const [isTerminal] = useSessionstorage('isTerminal');

  const { pageData } = submitedData || {};
  const redirectToTerminalMainPage = () => {
    if (isTerminal.isTerminal) {
      setTimeout(() => history.push(`/?siteId=${siteOptions.siteId}&source=terminal&language=${siteOptions.lng}`), 5000);
    } else if (redirectType.redirectType === 'employee') {
      setTimeout(() => history.push(`/employee/${employeeId.employeeId}?siteId=${siteOptions.siteId}`), 5000);
    } else if (redirectType.redirectType !== 'employee') {
      setTimeout(() => history.push(`/?siteId=${siteOptions.siteId}&language=${siteOptions.lng}`), 5000);
    }
  };

  useEffect(() => {
    props.hideLoader();
    redirectToTerminalMainPage();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { headline, response, bgColor, headlineColor } = pageData ? pageData : {};

  return (
    <div
      className={classNames({
        container: true,
        'w-full': true,
        'max-w-xs': true,
        'mx-auto': true,
        'bg-red-gradient': bgColor === 'red',
        'bg-green-gradient': bgColor === 'green',
        'bg-yellow-gradient': bgColor === 'yellow',
        'bg-white-gradient': bgColor === '#fff',
        'bg-black-gradient': bgColor === '#000',
      })}
    >
      <div className="successSubmit px-8 pt-6 pb-8 mb-4 mt-4">
        <br />
        <h1 className="rejectionTitle text-center mt-4" style={{ color: headlineColor }}>
          {headline || 'headline'}
        </h1>
        <p className="text-center text-white successText">{response || 'message'}</p>
      </div>
    </div>
  );
};
